import { toTwoDecimals } from '@/utils/convertNumber'
// <-> 合併後的資料呈現
// ex 禾豐有 3 types 就會另外給 solarInfo, mysqlInfo, powerInfo
// 最外層依照 solarInfo > mysqlInfo > powerInfo 順位放其中一種的 id, name, lon, lat, county 是 for 地圖用
// 外層 availability 是平均值 是 for 地圖用

// const mergedData = {
//   'name': '禾豐',
//   'types': [
//     'solarInfo',
//     'mysqlInfo',
//     'powerInfo'
//   ],
//   'availability': 0,
//   'solarInfo': {
//     'name': '禾豐',
//     'id': 'f005',
//     'lat': 22.71637,
//     'lon': 120.54331,
//     'county': '屏東縣',
//     'availability': 0
//   },
//   'mysqlInfo': {
//     'id': 'e008',
//     'name': '屏東禾豐示範案場',
//     'lat': 22.71637,
//     'lon': 120.54331,
//     'county': '屏東縣',
//     'availability': 0.8
//   },
//   'powerInfo': {
//     'name': '禾豐光用電展示案場',
//     'id': 'field001',
//     'lat': 22.71637,
//     'lon': 120.54331,
//     'county': '屏東縣',
//     'availability': 0.8
//   },
//   'id': 'f005',
//   'lon': 120.54331,
//   'lat': 22.71637,
//   'county': '屏東縣'
// }

// <-> 只有一種類型的資料呈現
// 雖然多餘另外放置獨立 obj (mysqlInfo), 但 call api 要取 params 比較好判斷

// const unmergedData = {
//   'id': 'e001',
//   'name': '觀音所',
//   'mysqlInfo': {
//     'id': 'e001',
//     'name': '觀音所',
//     'lat': 25.04776,
//     'lon': 121.517032,
//     'county': '桃園市',
//     'availability': 0.8
//   },
//   'types': [
//     'mysqlInfo'
//   ],
//   'lon': 121.517032,
//   'lat': 25.04776,
//   'county': '桃園市',
//   'availability': 0.8
// }

// 將 API 回傳的資料轉為地圖繪製所需格式
// 將 availabilityData, multipleTypeData 與 allInfo 進行合併
export function transformApiData (allInfo, availabilityData, multipleTypeData = []) {
  // 1. 建立 lookup 方便查找
  const lookup = {
    solarInfo: {},
    mysqlInfo: {},
    powerInfo: {}
  };

  // 用 name 為 key, 同時合併 availability 進去
  // 因 multipleTypeData 是找 name 來合併
  (allInfo.solarInfo || []).forEach((s) => {
    lookup.solarInfo[s.name] = {
      ...s,
      availability: availabilityData[s.id] ?? 80
    }
  });
  (allInfo.mysqlInfo || []).forEach((m) => {
    lookup.mysqlInfo[m.name] = {
      ...m,
      availability: availabilityData[m.id] ?? 80
    }
  });
  (allInfo.powerInfo || []).forEach((p) => {
    lookup.powerInfo[p.name] = {
      ...p,
      availability: availabilityData[p.id] ?? 80
    }
  })

  // 2. 按 multipleTypeData 進行合併
  const merged = multipleTypeData.map((mObj) => {
    const result = {
      name: mObj.solar || mObj.ess || mObj.power,
      types: []
    }

    if (mObj.solar && lookup.solarInfo[mObj.solar]) {
      result.solarInfo = lookup.solarInfo[mObj.solar]
      result.types.push('solarInfo')
    }
    if (mObj.ess && lookup.mysqlInfo[mObj.ess]) {
      result.mysqlInfo = lookup.mysqlInfo[mObj.ess]
      result.types.push('mysqlInfo')
    }
    if (mObj.power && lookup.powerInfo[mObj.power]) {
      result.powerInfo = lookup.powerInfo[mObj.power]
      result.types.push('powerInfo')
    }

    // 外層 availability 平均
    const avails = [result.solarInfo, result.mysqlInfo, result.powerInfo]
      .filter(Boolean)
      .map((d) => d.availability)

    result.availability = avails.length
      ? toTwoDecimals(avails.reduce((a, b) => a + b) / avails.length)
      : 80 // 若沒有，先放假的
    // ? Math.round((avails.reduce((a, b) => a + b) / avails.length) * 100) / 100

    result.id =
      result.solarInfo?.id || result.mysqlInfo?.id || result.powerInfo?.id
    result.lon =
      result.solarInfo?.lon || result.mysqlInfo?.lon || result.powerInfo?.lon
    result.lat =
      result.solarInfo?.lat || result.mysqlInfo?.lat || result.powerInfo?.lat
    result.county =
      result.solarInfo?.county ||
      result.mysqlInfo?.county ||
      result.powerInfo?.county

    return result
  })

  // 3. 沒有在 multipleTypeData 裡的單獨列出
  const usedNames = new Set(
    multipleTypeData.flatMap((m) => [m.solar, m.ess, m.power].filter(Boolean))
  )

  const singles = []
  Object.entries(lookup).forEach(([typeKey, dict]) => {
    Object.values(dict).forEach((site) => {
      if (!usedNames.has(site.name)) {
        singles.push({
          id: site.id,
          name: site.name,
          [typeKey]: site,
          types: [typeKey],
          lon: site.lon,
          lat: site.lat,
          county: site.county,
          availability: toTwoDecimals(site.availability)
        })
      }
    })
  })

  // 4. 合併輸出
  return [...merged, ...singles]
}
